import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
interface TeamPageProps {
  onOpenSampleModal?: () => void;
}
const teamMembers = [{
  name: 'Lorem Ipsum',
  role: 'Managing Director',
  bio: 'Leads strategy and operations with 28 years in industrial labelling and manufacturing.',
  photo: 'https://www.labelcentre.co.uk/wp-content/uploads/2021/09/Grey-Levels-Circles-01.png.webp'
}, {
  name: 'Lorem Ipsum',
  role: 'Lorem ipsum dolor',
  bio: 'Manages client relationships across UK and Europe, specialising in bespoke solutions.',
  photo: 'https://www.labelcentre.co.uk/wp-content/uploads/2021/09/Grey-Levels-Circles-02.png.webp'
}, {
  name: 'Lorem Ipsum',
  role: 'Lorem ipsum dolor',
  bio: 'Oversees manufacturing quality and delivery timelines for all standard and custom orders.',
  photo: 'https://www.labelcentre.co.uk/wp-content/uploads/2021/09/Grey-Levels-Circles-03.png.webp'
}, {
  name: 'Lorem Ipsum',
  role: 'Lorem ipsum dolor',
  bio: 'Creates compliant, functional label designs that work across materials and applications.',
  photo: 'https://www.labelcentre.co.uk/wp-content/uploads/2022/03/Grey-Levels-Circles-17-20.png.webp'
}, {
  name: 'Lorem Ipsum',
  role: 'Lorem ipsum dolor',
  bio: 'Helps customers navigate specifications, compliance requirements, and material selection.',
  photo: 'https://www.labelcentre.co.uk/wp-content/uploads/2021/09/Grey-Levels-Circles-13.png.webp'
}, {
  name: 'Lorem Ipsum',
  role: 'Lorem ipsum dolor',
  bio: 'Ensures smooth order processing, proofing workflows, and customer communication.',
  photo: 'https://www.labelcentre.co.uk/wp-content/uploads/2021/09/Grey-Levels-Circles-07.png.webp'
}, {
  name: 'Lorem Ipsum',
  role: 'Lorem ipsum dolor',
  bio: 'Supports new product development and quality assurance across all manufacturing lines.',
  photo: 'https://www.labelcentre.co.uk/wp-content/uploads/2021/09/Grey-Levels-Circles-04.png.webp'
}];
export function TeamPage({
  onOpenSampleModal
}: TeamPageProps) {
  return <div className="min-h-screen bg-white font-sans text-[#0A1628] selection:bg-[#0052CC] selection:text-white overflow-x-hidden" data-id="element-1522">
      <Header onOpenSampleModal={onOpenSampleModal} data-id="element-1523" />

      <main className="pt-[135px] md:pt-[145px]" data-id="element-1524">
        {/* Hero */}
        <section className="py-16 md:py-24 bg-white text-center" data-id="element-1525">
          <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-1526">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-1527">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#0A1628] tracking-tight leading-[1.08] mb-6" data-id="element-1528">
                Meet our team
              </h1>
              <p className="text-xl text-slate-500 max-w-2xl mx-auto leading-relaxed" data-id="element-1529">
                The people behind UK's leading industrial label manufacturer,
                combining decades of experience and technical expertise
              </p>
            </motion.div>
          </div>
        </section>

        {/* Team Grid */}
        <section className="py-16 md:py-20 bg-slate-50" data-id="element-1530">
          <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-1531">
            <div className="text-center mb-14" data-id="element-1532">
              <h2 className="text-3xl md:text-4xl font-extrabold text-[#0A1628] tracking-tight mb-3" data-id="element-1533">
                The team
              </h2>
              <p className="text-lg text-slate-500" data-id="element-1534">
                Built on decades of manufacturing knowledge and real industry
                experience
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1535">
              {teamMembers.map((member, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.08
            }} className="bg-white rounded-2xl p-8 border border-slate-100 flex flex-col items-center text-center" data-id="element-1536">
                  {/* Photo */}
                  <div className="h-24 w-24 rounded-full overflow-hidden bg-slate-100 mb-5 flex-shrink-0" data-id="element-1537">
                    <img src={member.photo} alt={member.role} className="w-full h-full object-cover" data-id="element-1538" />
                  </div>
                  <h3 className="text-lg font-bold text-[#0A1628] mb-1" data-id="element-1539">
                    {member.name}
                  </h3>
                  <p className="text-sm font-semibold text-[#0052CC] mb-3" data-id="element-1540">
                    {member.role}
                  </p>
                  <p className="text-slate-500 text-sm leading-relaxed" data-id="element-1541">
                    {member.bio}
                  </p>
                </motion.div>)}
            </div>

            {/* Join Us */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mt-16 py-12 border-t border-slate-200" data-id="element-1542">
              <h3 className="text-2xl font-bold text-[#0A1628] mb-3" data-id="element-1543">
                Join us
              </h3>
              <p className="text-slate-500 mb-6" data-id="element-1544">
                We're always looking for talented people to join our growing
                team
              </p>
              <a href="/careers" className="inline-flex items-center px-6 py-3 border border-[#0A1628] text-[#0A1628] font-semibold rounded-full hover:bg-[#0A1628] hover:text-white transition-colors" data-id="element-1545">
                View roles
              </a>
            </motion.div>
          </div>
        </section>

        {/* What Sets Us Apart */}
        <section className="py-16 md:py-24 bg-white" data-id="element-1546">
          <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-1547">
            <div className="text-center mb-14" data-id="element-1548">
              <span className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3 block" data-id="element-1549">
                Expertise
              </span>
              <h2 className="text-3xl md:text-4xl font-extrabold text-[#0A1628] tracking-tight mb-3" data-id="element-1550">
                What sets us apart
              </h2>
              <p className="text-lg text-slate-500" data-id="element-1551">
                We solve real problems for demanding industries with speed and
                precision
              </p>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white border border-slate-100 rounded-[32px] overflow-hidden shadow-sm" data-id="element-1552">
              <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-1553">
                <div className="aspect-[4/3] lg:aspect-auto bg-slate-100" data-id="element-1554">
                  <img src="https://cdn.magicpatterns.com/uploads/qszDzSmxSCirrNe3REUbpj/nameplates-industial.webp" alt="Industrial manufacturing" className="w-full h-full object-cover" data-id="element-1555" />
                </div>
                <div className="p-10 lg:p-16 flex flex-col justify-center" data-id="element-1556">
                  <span className="text-xs font-bold text-[#0052CC] uppercase tracking-widest mb-4 block" data-id="element-1557">
                    Proven
                  </span>
                  <h3 className="text-2xl md:text-3xl font-bold text-[#0A1628] mb-4 leading-tight" data-id="element-1558">
                    Responsive support when it matters most
                  </h3>
                  <p className="text-slate-500 leading-relaxed mb-8" data-id="element-1559">
                    Your engineers and procurement teams get direct access to
                    people who understand compliance, materials, and timelines.
                    No gatekeeping, no delays. We answer questions properly
                    because we've been doing this work ourselves for decades.
                  </p>
                  <div className="flex flex-wrap items-center gap-4" data-id="element-1560">
                    <a href="/about" className="px-6 py-3 bg-[#0A1628] text-white font-semibold rounded-full hover:bg-[#0052CC] transition-colors" data-id="element-1561">
                      Learn more
                    </a>
                    <a href="/about" className="inline-flex items-center text-sm font-semibold text-[#0A1628] hover:text-[#0052CC] transition-colors" data-id="element-1562">
                      About us <ArrowRight className="ml-1 h-4 w-4" data-id="element-1563" />
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1564" />
    </div>;
}